import useGetApi from '../useGetApi';

export interface RebateLineItem {
  id: string;
  date: string;
  invoiceId: string;
  divisionId: string;
  divisionName: string | null;
  productGroupId: string | null;
  productGroupName: string | null;
  value: number;
  currency: string;
  isHistorical: boolean;
}

// useGetApi unwraps the response, so this is the structure after unwrapping
export interface RebateLineItemsResponse {
  lineItems: RebateLineItem[];
}

export interface LineItemFilters {
  startDate?: string;
  endDate?: string;
}

// Get line items for a rebate agreement
export const useRebateLineItemsByAgreement = (
  agreementId: string,
  filters?: LineItemFilters,
  enabled = true,
) => {
  const queryParams = new URLSearchParams();

  if (filters?.startDate) queryParams.append('startDate', filters.startDate);
  if (filters?.endDate) queryParams.append('endDate', filters.endDate);

  const queryString = queryParams.toString();
  const endpoint = `rebates/line-items/agreement/${agreementId}${
    queryString ? `?${queryString}` : ''
  }`;

  return useGetApi<RebateLineItemsResponse>({
    endpoint,
    options: {
      enabled: enabled && !!agreementId,
    },
  });
};
